import { WeekIdentifier } from '../Incrementals.types';
import { UiCommands } from './UiCommands';

export function changeWeekCommand(
  this: UiCommands,
  weekId: WeekIdentifier
): void {
  // This ensures data integrity to expose certain types of bugs at an earlier point in sequence;
  // that the week parameter must exist in list of weeks
  const newCurrentWeek = this.uiState.weeks.filter(
    (weekElement) =>
      weekElement.weekId.startOfWeek.isSame(weekId.startOfWeek) &&
      weekElement.weekId.endOfWeek.isSame(weekId.endOfWeek)
  )[0];

  this.uiState.currentWeekId = newCurrentWeek.weekId;
  this.setUiStateTriggerReRender(this.uiState);
}
